<template>
  <div class="flex flex-col items-center justify-center min-h-[60vh] text-center px-6">
    <div class="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-6">
      <i class="fas fa-lock text-red-400 text-3xl"></i>
    </div>
    <h1 class="text-xl font-bold text-gray-900 mb-2">Accès non autorisé</h1>
    <p class="text-sm text-gray-500 mb-6 max-w-md leading-relaxed">
      Vous n'avez pas les permissions nécessaires pour accéder à cette page.
      Contactez votre administrateur pour obtenir les accès appropriés.
    </p>
    <div class="flex items-center gap-3">
      <button
        v-if="firstAllowedRoute"
        class="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-white bg-primary hover:bg-primary-dark rounded-lg transition-colors"
        @click="$router.push(firstAllowedRoute)">
        <i class="fas fa-arrow-left text-xs"></i>
        Aller à la page d'accueil
      </button>
      <button
        class="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
        @click="$router.push({ name: 'profile' })">
        <i class="fas fa-user text-xs"></i>
        Mon profil
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useAuthStore } from '@/store/modules/auth'
import { usePermissionsStore } from '@/store/modules/permissions'

export default defineComponent({
  name: 'AccessDeniedView',
  setup() {
    const authStore = useAuthStore()
    const permissionsStore = usePermissionsStore()

    // Route priority order for redirect
    const routePriority = [
      { name: 'dashboard', permission: 'dashboard' },
      { name: 'cash-registers', permission: 'cash-registers' },
      { name: 'sales', permission: 'sales' },
      { name: 'products', permission: 'products' },
      { name: 'customers', permission: 'customers' },
      { name: 'suppliers', permission: 'suppliers' },
    ]

    const firstAllowedRoute = computed(() => {
      if (authStore.isAdmin) return { name: 'dashboard' }

      for (const route of routePriority) {
        if (permissionsStore.hasPermission(route.permission)) {
          return { name: route.name }
        }
      }
      return null
    })

    return { firstAllowedRoute }
  }
})
</script>
